import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { GrammaticalAccuracy } from "@modules/elearning/lead";

const GrammaticalRangeAndAccuracy = () => {
  return (
    <LayoutMain
      title="Band 7+ IELTS Writing Masterclass - Elevate Your Grammatical Range and Accuracy!"
      footer_with_evaluation
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/elearning/grammatical-range-and-accuracy`}
    >
      <GrammaticalAccuracy />
    </LayoutMain>
  );
};

export default GrammaticalRangeAndAccuracy;
